import { Table } from '@octano/global-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import useColumns from '../hooks/useColumns';
import { useFinantialOthersState } from '../hooks/useFinantialOthersState';

export function FinantialOtherPaymentByAcademicLevel() {
  const { t } = useTranslation(
    TranslationsKeys.CONFIGURATION_FIANANTIAL_OTHERS,
  );
  const {
    academicLevelsPriceState,
    setAcademicLevelsPriceState,
  } = useFinantialOthersState();

  const [tableKey, setTableKey] = useState(0);

  const columns = useColumns({
    translateKey: 'academicLevelTitulationPayment',
    onChangeValue: (typeId, fieldName, fieldValue) => {
      setAcademicLevelsPriceState((prev) =>
        prev.map((c) =>
          c.id === typeId ? { ...c, [fieldName]: fieldValue } : c,
        ),
      );
    },
    onCheck: (typeId, paymentRequired) => {
      setTableKey(tableKey + 1);
      setAcademicLevelsPriceState((prev) =>
        prev.map((c) =>
          c.id === typeId
            ? {
                ...c,
                paymentRequired,
                paymentAmount: paymentRequired ? c.paymentAmount : undefined,
              }
            : c,
        ),
      );
    },
  });

  return (
    <div>
      <p className="fs-16 fw-600 text-primary mt-4 mb-0">
        {t('academicLevelTitulationPayment.title')}
      </p>
      <p className="fs-14 mb-3">
        {t('academicLevelTitulationPayment.description')}
      </p>
      <Table key={tableKey} columns={columns} data={academicLevelsPriceState} />
    </div>
  );
}
